// src/components/padrekko/qc/CompletionCountsBar.jsx
//
// Compact remediation-completion tally — { completed, not_completed, pending,
// total }. Rendered at case level and per-pad (a pad == a "site"). Pure derived
// view over the findings already loaded with the case; no extra fetch.

import { countCompletion } from "./completionCounts";

export default function CompletionCountsBar({ findings, label = null, className = "" }) {
  const c = countCompletion(findings);
  if (c.total === 0) return null;
  return (
    <div className={`flex items-center gap-2 text-[9px] tabular-nums ${className}`}>
      {label && <span className="font-mono uppercase tracking-widest text-fg-secondary">{label}</span>}
      <span className="text-emerald-400" title="Completed">● {c.completed}</span>
      <span className="text-amber-400" title="Not completed">● {c.not_completed}</span>
      <span className="text-red-400" title="Pending">● {c.pending}</span>
      <span className="text-fg-secondary">/ {c.total}</span>
    </div>
  );
}
